import { Box, IconButton } from '@mui/material';
import { useCallback } from 'react';
import ChevronRightOutlined from '@icons/ChevronRightOutlined';

export interface DetailsButtonProps<T> {
  params: T;
  onClick: (params: T) => void;
}
const DetailsButton = <T,>({ params, onClick }: DetailsButtonProps<T>) => {
  const onClicked = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      onClick(params);
    },
    [params, onClick]
  );
  return (
    <Box sx={{ flex: 1, justifyContent: 'flex-end', display: 'flex', alignItems: 'center', height: '100%' }}>
      <IconButton size="small" onClick={onClicked}>
        <ChevronRightOutlined />
      </IconButton>
    </Box>
  );
};
export default DetailsButton;
